import { useDisclosure } from '@chakra-ui/react';
import { ReportingContainerBaseConfig } from '../../../base';
import { TaskItemController, TaskItemLoader } from './taskItemInterface';
import { TaskItemContainerProps } from './taskItemProps';

export function createTaskItemContainer(
    config: ReportingContainerBaseConfig,
    loader: TaskItemLoader,
    controller: TaskItemController
): React.FC<TaskItemContainerProps> {
    const {
        context: { useContext },
    } = config;
    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, {
            task: containerProps.task,
        });
        const props = controller.useProps(context, data, {
            disclosure: useDisclosure({ defaultIsOpen: false }),
        });
        return <View {...props} />;
    };
}
